import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./ProfileSlice";

export default configureStore({
    reducer: {
        user: userReducer
    }
});